<template>
  <div style="padding: 0 15px;">
    <!-- 共享搜索区 -->
     <div class="search-wrap" style="margin-top: 5px">
       <div class="spacing">
        <el-select size="mini" v-model="params.pid_a" placeholder="选择部门架构1" filterable class="w200" @change="changeDepa">
          <el-option v-for="item in paList" :key="item.id" :label="item.short_name" :value="item.id" />
        </el-select>
        <el-select size="mini" v-model="params.pid_b" placeholder="选择部门架构2" clearable filterable class="w200" v-if="pbList != ''" @change="changeDepb">
          <el-option v-for="item in pbList" :key="item.id" :label="item.short_name" :value="item.id" />
        </el-select>
        <el-select size="mini" v-model="params.pid_c" placeholder="选择部门架构3" clearable filterable class="w200" v-if="pcList != ''" @change="changeDepc">
          <el-option v-for="item in pcList" :key="item.id" :label="item.short_name" :value="item.id" />
        </el-select>
        <el-select size="mini" v-model="params.pid_d" placeholder="选择部门架构4" clearable filterable class="w200" v-if="pdList != ''" @change="changeDepd">
          <el-option v-for="item in pdList" :key="item.id" :label="item.short_name" :value="item.id" />
        </el-select>
        <el-select size="mini" v-model="params.pid_e" placeholder="选择部门架构5" clearable filterable class="w200" v-if="peList != ''">
          <el-option v-for="item in peList" :key="item.id" :label="item.short_name" :value="item.id" />
        </el-select>
      </div> 
      <div class="spacing" style="float: right; cursor: pointer; line-height: 28px;" @click="showFilter = !showFilter">
        <i :class="showFilter ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
        {{ showFilter ? '收起' : '展开' }}
      </div>
    </div>
    <div class="search-wrap" style="margin-top: 5px" v-show="showFilter">
      <div class="spacing">
        <el-cascader
          filterable
          :options="flowTypeOptions"
          :props="{ label: 'label', value: 'value', children: 'children', emitPath: false, checkStrictly: true, multiple: true, collapseTags: true }"
          v-model="flowTypePath"
          size="mini"
          clearable
          placeholder="流程类型"
          style="width: 250px"
          @change="onFlowTypeChange">
        </el-cascader>
      </div>
      <div class="spacing" v-if="activeTab === 'list'">
        <el-input size="mini" placeholder="节点审批人" clearable v-model="self_where.node_user_name" @focus="selectNodeUser" @clear="self_where.node_user_id = ''" style="width: 150px"></el-input>
      </div>
      <div class="spacing">
        <el-select size="mini" v-model="self_where.timeout_type" placeholder="请选择审批时长" style="width: 150px">
          <el-option label="超24小时" :value=24></el-option>
          <el-option label="超48小时" :value=48></el-option>
          <el-option label="超72小时" :value=72></el-option>
          <el-option label="超1周以上" :value=168></el-option>
        </el-select>
      </div>
      <div class="spacing">
        接收日期
        <el-date-picker v-model="self_where.start_timeout" size="mini" type="date" value-format="yyyy-MM-dd" placeholder="开始日期"></el-date-picker>
        至
        <el-date-picker v-model="self_where.end_timeout" size="mini" type="date" value-format="yyyy-MM-dd" placeholder="结束日期"></el-date-picker>
      </div>
      <div class="spacing">
        <!-- <el-button size="mini" type="primary" @click="search">搜索</el-button> -->
      </div>
    </div>

    <!-- Tab 切换：图表 / 列表 -->
    <el-tabs v-model="activeTab" @tab-click="onTabClick">
      <!-- 图表统计 -->
      <el-tab-pane label="统计报表" name="chart">
        <div class="chart-wrap" style="width: 100%">
          <el-row :gutter="10">
            <el-col :span="12">
              <div class="chart-card border" v-loading="loading">
                <div class="chart-title">当前超时审批流程统计（按部门）</div>
                <div ref="chartAreaTimeOut" class="chart-box"></div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="chart-card border" v-loading="loading">
                <div class="chart-title">当前超时审批流程统计（按类型）</div>
                <div ref="chartTypeTimeOut" class="chart-box"></div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="10" style="margin-top: 10px">
            <el-col :span="12">
              <div class="chart-card border" v-loading="loading">
                <div class="chart-title">当前未结束流程数据统计（按部门）</div>
                <div ref="chartUnfinishedDept" class="chart-box"></div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="chart-card border" v-loading="loading">
                <div class="chart-title">流程数量统计（按类型）</div>
                <div ref="chartFlowStats" class="chart-box"></div>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-tab-pane>

      <!-- 超时列表 -->
      <el-tab-pane label="超时列表" name="list">
        <div class="list-wrap" :style="{ height: tableMaxHeight + 'px' }">
          <el-table :data="pageData.list" style="width: 100%" v-loading="loading" :height="tableMaxHeight - 50">
            <el-table-column prop="task_id" label="流程ID" width="120" fixed="left"></el-table-column>
            <el-table-column prop="process_name" label="流程名称" show-overflow-tooltip>
              <template slot-scope="scope">
                <span :title="scope.row.process_name">{{ scope.row.process_name }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="flow_type_name" label="流程类型" width="150"></el-table-column>
            <el-table-column prop="department_name" label="部门" width="220" show-overflow-tooltip></el-table-column>
            <el-table-column prop="create_user_name" label="发起人" width="100"></el-table-column>
            <el-table-column prop="node_name" label="当前审批节点" width="140"></el-table-column>
            <el-table-column prop="user_name" label="当前审批人员" width="100"></el-table-column>
            <el-table-column prop="posted_time" label="节点接收时间" width="160">
              <template slot-scope="scope">
                <span>{{ scope.row.posted_time ? formatTime(scope.row.posted_time) : '' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="duration_hour" label="超时时长(小时)" width="140">
              <template slot-scope="scope">
                <span>{{ scope.row.duration_hour ? scope.row.duration_hour : '-' }}</span>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination-wrap">
            <el-pagination background layout="prev, pager, next" :total="pageData.total*1" :page-size="pageData.pageSize*1" :current-page="pageData.page*1" @current-change="pageChange"></el-pagination>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <DepartmentSelect ref="DepartmentSelect" @onSelected="onSelected"/>
    <select-personnel ref="selectPersonnel" />
    <!--流程表单详情-->
    <el-dialog title="查看" :visible.sync="dialogVisible" :close-on-click-modal="false" width="1000px">
      <el-row>
        <el-col :span="24">
          <div>
            <v-form-render v-if="form_status" :form-json="formJson" :form-data="formData" :option-data="optionData" ref="vFormRef">
            </v-form-render>
          </div>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import * as echarts from 'echarts';
import Http from "./common/Http";
import selectPersonnel from "../Personnel/components/selectPersonnel";
import DepartmentSelect from "../../common/departmentSelect";

export default {
  name:"FlowTimeOutChar",
  components:{selectPersonnel,DepartmentSelect},
  data () {
    const pad = n => String(n).padStart(2, '0')
    const formatDate = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
    const now = new Date()
    const sevenDaysAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000)
    const defaultEnd = formatDate(now)
    const defaultStart = formatDate(sevenDaysAgo)
    return {
      activeTab: 'chart',
      showFilter: true,
      loading: false,
      dialogVisible: false,
      self_where: {
        process_name: '',
        node_user_name: '',
        node_user_id: '',
        start_timeout: defaultStart,
        end_timeout: defaultEnd,
        node_name: '',
        is_finish: '',
        master_id: '',
        type_id: '',
        timeout_type: 24,
        department_name: '',
        department_id: '',
        department_ids: [],
      },
      pageData: {
        list: [],
        total: 0,
        pageSize: 20,
        page: 1
      },
      searchProjectData: [],
      flowTypeOptions: [],
      flowTypePath: [],
      optionData: {},
      formJson: {},
      formData: {},
      form_status: false,
      chartInstances: {},
      tableMaxHeight: 500,
      paList: [],
      pbList: [],
      pcList: [],
      pdList: [],
      peList: [],
      params: {
        pid_a: '',
        pid_b: '',
        pid_c: '',
        pid_d: '',
        pid_e: '',
      },
    }
  },
  mounted() {
    this.calcTableHeight()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    Object.values(this.chartInstances).forEach(c => c && c.dispose())
    this.chartInstances = {}
  },
  created() {
    this.getFlowTypeTree()
    this.loadPaList()
  },
  watch: {
    self_where: {
      handler() {
        if (this._searchTimer) clearTimeout(this._searchTimer)
        this._searchTimer = setTimeout(() => {
          this.search()
        }, 300)
      },
      deep: true
    },
    params: {
      handler() {
        if (this._searchTimer) clearTimeout(this._searchTimer)
        this._searchTimer = setTimeout(() => {
          this.search()
        }, 300)
      },
      deep: true
    }
  },
  methods: {
    handleResize() {
      Object.values(this.chartInstances).forEach(c => c && c.resize())
      this.calcTableHeight()
    },
    calcTableHeight() {
      // 减去搜索栏、tab栏、分页、padding等预留高度
      this.tableMaxHeight = window.innerHeight - 280
    },
    onTabClick() {
      if (this.activeTab === 'chart') {
        this.loadAllCharts()
      } else {
        this.pageData.page = 1
        this.getList()
      }
    },
    search() {
      if (this.activeTab === 'chart') {
        this.loadAllCharts()
      } else {
        this.pageData.page = 1
        this.getList()
      }
    },
    // ========== 图表相关 ==========
    loadAllCharts() {
      const that = this;
      const params = this.getReportParams()
      const key = JSON.stringify(params)
      if (this._lastChartParamsKey === key) return
      this._lastChartParamsKey = key
      that.loading = true

      const renderAll = (allData) => {
        that.loading = false
        const data = allData || {}
        that.renderDeptTimeoutChart(data.dept_timeout || [])
        that.renderTypeTimeoutChart(data.type_timeout || [])
        that.renderDeptUnfinishedChart(data.dept_unfinished || [])
        that.renderTypeUnfinishedChart(data.type_unfinished || [])
      }

      Http.get("flow/FlowReport/getTimeOutAllReport", params, res => {
        if (res.code) {
          renderAll(res.data || {})
        } else {
          that.loading = false
        }
      })
    },
    // ========== 列表相关 ==========
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    getList() {
      const that = this;
      const params = this.getReportParams()
      const key = JSON.stringify(params) + '_page_' + this.pageData.page
      if (this._lastListParamsKey === key) return
      this._lastListParamsKey = key
      that.loading = true;
      Http.get("flow/FlowReport/flowTimeOutListV2",{
        ...params,
        page: this.pageData.page,
        page_size: this.pageData.pageSize
      },res=>{
        if(res.code) {
          const data = res.data || {}
          that.pageData = {
            list: data.list || [],
            total: Number(data.total) || 0,
            page: Number(data.page) || that.pageData.page,
            pageSize: Number(data.pageSize) || that.pageData.pageSize,
          }
        }
        that.loading = false;
      })
    },
    // ========== 公共方法 ==========
    selectNodeUser() {
      const that = this;
      let config = {
        department_id:null,
          role_id:null,
          user_ids:null,
          user_len:1,
          type:"",
      }
      that.$refs.selectPersonnel.show(config,data=>{
        if(data){
          let name = ''
          let select_user_id = 0
          data.map(ret=>{
            name = ret.name
            select_user_id = ret.id
          })
          that.self_where.node_user_name = name
          that.self_where.node_user_id = select_user_id
        }
      })
    },
    getFlowTypeTree() {
      Http.get("flow/FlowType/getFlowTypeTree",{},res=>{
        if(res.code) {
          const list = res.data || []
          this.flowTypeOptions = list.map(item => this.transformFlowType(item))
        }
      })
    },
    transformFlowType(item) {
      const node = { value: item.id, label: item.name }
      if (item.children && item.children.length) {
        node.children = item.children.map(child => this.transformFlowType(child))
      }
      return node
    },
    onFlowTypeChange(val) {
      if (!val || !val.length) {
        this.self_where.type_id = ''
        this.flowTypePath = []
      } else {
        this.self_where.type_id = val.join(',')
      }
    },
    formatTime(timestamp) {
      if (!timestamp) return ''
      const ts = String(timestamp).length <= 10 ? Number(timestamp) * 1000 : Number(timestamp)
      const d = new Date(ts)
      if (isNaN(d.getTime())) return ''
      const pad = n => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    },
    getReportParams() {
      let where = JSON.parse(JSON.stringify(this.self_where));
      Object.keys(where).forEach(key => {
        if (key.endsWith('_name')) {
          delete where[key]
        }
      })
      let deptList = []
      if (this.peList && this.peList.length) {
        deptList = this.peList
      } else if (this.pdList && this.pdList.length) {
        deptList = this.pdList
      } else if (this.pcList && this.pcList.length) {
        deptList = this.pcList
      } else if (this.pbList && this.pbList.length) {
        deptList = this.pbList
      } else if (this.paList && this.paList.length) {
        deptList = this.paList
      }
      where.department_ids = deptList.map(item => item.id)
      return where
    },
    // ========== 图表渲染 ==========
    renderDeptTimeoutChart(data) {
      const xData = data.map(item => item.department_name)
      const yFlowData = data.map(item => item.process_count)
      const yTimeoutData = data.map(item => item.timeout_count)
      const yPropData = data.map(item => item.process_count ? ((item.timeout_count / item.process_count) * 100).toFixed(1) : 0)

      const tooltipFormatter = {
        trigger: 'axis',
        axisPointer: { type: 'cross', crossStyle: { color: '#999' } },
        formatter: function(params) {
          let result = params[0].name + '<br/>'
          params.forEach(item => {
            let val = item.value
            if (item.seriesName.includes('占比')) val = val + '%'
            result += item.marker + ' ' + item.seriesName + ': ' + val + '<br/>'
          })
          return result
        }
      }
      const option = {
        tooltip: tooltipFormatter,
        legend: { data: ['流程数量', '超时数量', '超时占比'], top: 5 },
        grid: { left: '3%', right: '4%', bottom: '12%', containLabel: true },
        xAxis: { type: 'category', data: xData, axisPointer: { type: 'shadow' }, axisLabel: { interval: 0, rotate: 30 } },
        yAxis: [
          { type: 'value', name: '数量', axisLabel: { formatter: '{value}' } },
          { type: 'value', name: '占比(%)', axisLabel: { formatter: '{value}%' } }
        ],
        series: [
          { name: '流程数量', type: 'bar', data: yFlowData, label: { show: true, position: 'top' }, itemStyle: { color: '#409EFF' } },
          { name: '超时数量', type: 'bar', data: yTimeoutData, label: { show: true, position: 'top' }, itemStyle: { color: '#E6A23C' } },
          { name: '超时占比', type: 'line', yAxisIndex: 1, data: yPropData, smooth: true, itemStyle: { color: '#E6A23C' } }
        ]
      }
      this.renderChart('chartAreaTimeOut', option)
    },
    renderTypeTimeoutChart(data) {
      const xData = data.map(item => item.type_name)
      const yFlowData = data.map(item => item.process_count)
      const yTimeoutData = data.map(item => item.timeout_count)
      const yPropData = data.map(item => item.process_count ? ((item.timeout_count / item.process_count) * 100).toFixed(1) : 0)

      const tooltipFormatter = {
        trigger: 'axis',
        axisPointer: { type: 'cross', crossStyle: { color: '#999' } },
        formatter: function(params) {
          let result = params[0].name + '<br/>'
          params.forEach(item => {
            let val = item.value
            if (item.seriesName.includes('占比')) val = val + '%'
            result += item.marker + ' ' + item.seriesName + ': ' + val + '<br/>'
          })
          return result
        }
      }
      const option = {
        tooltip: tooltipFormatter,
        legend: { data: ['流程数量', '超时数量', '超时占比'], top: 5 },
        grid: { left: '3%', right: '4%', bottom: '12%', containLabel: true },
        xAxis: { type: 'category', data: xData, axisPointer: { type: 'shadow' }, axisLabel: { interval: 0, rotate: 30 } },
        yAxis: [
          { type: 'value', name: '数量', axisLabel: { formatter: '{value}' } },
          { type: 'value', name: '占比(%)', axisLabel: { formatter: '{value}%' } }
        ],
        series: [
          { name: '流程数量', type: 'bar', data: yFlowData, label: { show: true, position: 'top' }, itemStyle: { color: '#409EFF' } },
          { name: '超时数量', type: 'bar', data: yTimeoutData, label: { show: true, position: 'top' }, itemStyle: { color: '#E6A23C' } },
          { name: '超时占比', type: 'line', yAxisIndex: 1, data: yPropData, smooth: true, itemStyle: { color: '#E6A23C' } }
        ]
      }
      this.renderChart('chartTypeTimeOut', option)
    },
    renderDeptUnfinishedChart(data) {
      const xData = data.map(item => item.department_name)
      const yFlowData = data.map(item => item.pending_count)
      const yTimeoutData = data.map(item => item.timeout_count)
      const yPropData = data.map(item => item.pending_count ? ((item.timeout_count / item.pending_count) * 100).toFixed(1) : 0)

      const tooltipFormatter = {
        trigger: 'axis',
        axisPointer: { type: 'cross', crossStyle: { color: '#999' } },
        formatter: function(params) {
          let result = params[0].name + '<br/>'
          params.forEach(item => {
            let val = item.value
            if (item.seriesName.includes('占比')) val = val + '%'
            result += item.marker + ' ' + item.seriesName + ': ' + val + '<br/>'
          })
          return result
        }
      }
      const option = {
        tooltip: tooltipFormatter,
        legend: { data: ['待办数量', '超时数量', '超时占比'], top: 5 },
        grid: { left: '3%', right: '4%', bottom: '12%', containLabel: true },
        xAxis: { type: 'category', data: xData, axisPointer: { type: 'shadow' }, axisLabel: { interval: 0, rotate: 30 } },
        yAxis: [
          { type: 'value', name: '数量', axisLabel: { formatter: '{value}' } },
          { type: 'value', name: '占比(%)', axisLabel: { formatter: '{value}%' } }
        ],
        series: [
          { name: '待办数量', type: 'bar', data: yFlowData, label: { show: true, position: 'top' }, itemStyle: { color: '#409EFF' } },
          { name: '超时数量', type: 'bar', data: yTimeoutData, label: { show: true, position: 'top' }, itemStyle: { color: '#E6A23C' } },
          { name: '超时占比', type: 'line', yAxisIndex: 1, data: yPropData, smooth: true, itemStyle: { color: '#E6A23C' } }
        ]
      }
      this.renderChart('chartUnfinishedDept', option)
    },
    renderTypeUnfinishedChart(data) {
      const xData = data.map(item => item.type_name)
      const yTotalData = data.map(item => item.process_count)
      const yTodoData = data.map(item => item.pending_count)
      const yPropData = data.map(item => item.process_count ? ((item.pending_count / item.process_count) * 100).toFixed(1) : 0)

      const tooltipFormatter = {
        trigger: 'axis',
        axisPointer: { type: 'cross', crossStyle: { color: '#999' } },
        formatter: function(params) {
          let result = params[0].name + '<br/>'
          params.forEach(item => {
            let val = item.value
            if (item.seriesName.includes('占比')) val = val + '%'
            result += item.marker + ' ' + item.seriesName + ': ' + val + '<br/>'
          })
          return result
        }
      }
      const option = {
        tooltip: tooltipFormatter,
        legend: { data: ['流程总数', '待办数量', '待办占比'], top: 5 },
        grid: { left: '3%', right: '4%', bottom: '12%', containLabel: true },
        xAxis: { type: 'category', data: xData, axisPointer: { type: 'shadow' }, axisLabel: { interval: 0, rotate: 30 } },
        yAxis: [
          { type: 'value', name: '数量', axisLabel: { formatter: '{value}' } },
          { type: 'value', name: '占比(%)', axisLabel: { formatter: '{value}%' } }
        ],
        series: [
          { name: '流程总数', type: 'bar', data: yTotalData, label: { show: true, position: 'top' }, itemStyle: { color: '#409EFF' } },
          { name: '待办数量', type: 'bar', data: yTodoData, label: { show: true, position: 'top' }, itemStyle: { color: '#E6A23C' } },
          { name: '待办占比', type: 'line', yAxisIndex: 1, data: yPropData, smooth: true, itemStyle: { color: '#E6A23C' } }
        ]
      }
      this.renderChart('chartFlowStats', option)
    },
    renderChart(refName, option) {
      this.$nextTick(() => {
        const el = this.$refs[refName]
        if (!el) return
        if (this.chartInstances[refName]) {
          this.chartInstances[refName].setOption(option, true)
        } else {
          this.chartInstances[refName] = echarts.init(el)
          this.chartInstances[refName].setOption(option)
        }
      })
    },
    // ========== 部门架构 ==========
    loadPaList() {
      const that = this;
      Http.get('department/Company/getHrmChildren', {status: 1, parent_id: 0, is_show: 1}, res => {
        if (res.code == 1) {
          that.paList = res.data;
          that.params.pid_a = 3918
          Http.get('department/Company/getHrmChildren', {status: 1, parent_id: 3918, is_show: 1}, res2 => {
            if (res2.code == 1) {
              that.pbList = res2.data;
              that.loadAllCharts()
              that.getList()
            }
          });
        }
      });
    },
    changeDepa(value) {
      const that = this;
      that.pbList = []
      that.pcList = []
      that.pdList = []
      that.peList = []
      that.params.pid_b = ''
      that.params.pid_c = ''
      that.params.pid_d = ''
      that.params.pid_e = ''
      if (value > 0) {
        Http.get('department/Company/getHrmChildren', {status: 1, parent_id: value, is_show: 1}, res => {
          if (res.code == 1) { that.pbList = res.data; }
        });
      }
    },
    changeDepb(value) {
      const that = this;
      that.pcList = []
      that.pdList = []
      that.peList = []
      that.params.pid_c = ''
      that.params.pid_d = ''
      that.params.pid_e = ''
      if (value > 0) {
        Http.get('department/Company/getHrmChildren', {status: 1, parent_id: value, is_show: 1}, res => {
          if (res.code == 1) { that.pcList = res.data; }
        });
      }
    },
    changeDepc(value) {
      const that = this;
      that.pdList = []
      that.peList = []
      that.params.pid_d = ''
      that.params.pid_e = ''
      if (value > 0) {
        Http.get('department/Company/getHrmChildren', {status: 1, parent_id: value, is_show: 1}, res => {
          if (res.code == 1) { that.pdList = res.data; }
        });
      }
    },
    changeDepd(value) {
      const that = this;
      that.peList = []
      that.params.pid_e = ''
      if (value > 0) {
        Http.get('department/Company/getHrmChildren', {status: 1, parent_id: value, is_show: 1}, res => {
          if (res.code == 1) { that.peList = res.data; }
        });
      }
    },
    searchProject() {
      let type = ""
      if (this.searchProjectData.length > 0) {
        if(typeof this.searchProjectData[0] === "object") {
          type = "search"
        }
      }
      this.$refs.DepartmentSelect.show(type, this.searchProjectData)
    },
    onSelected(type, data) {
      this.searchProjectData = data
      this.self_where.department_ids = [];
      this.self_where.department_name = "";
      let that = this
      let projectStrArr = [];
      data.forEach(function (item){
        that.self_where.department_ids.push(item.id)
        projectStrArr.push(item.ancestor_name)
      })
      this.self_where.department_name = projectStrArr.join(",")
    },
  }
}
</script>
<style lang="scss" scoped>

@import './common.scss';

.spacing {
  display: inline-block;
  margin-right: 10px;
  margin-top: 10px;
}
.list-wrap{
  width: 100%;
  display: flex;
  flex-direction: column;
}
.pagination-wrap{
  margin-top: 10px;
  text-align: right;
  flex-shrink: 0;
}
.chart-wrap {
  padding: 10px 0;
}
.chart-card {
  background: #fff;
  border-radius: 4px;
  padding: 10px;
  margin-bottom: 10px;
}
.chart-title {
  font-size: 14px;
  font-weight: bold;
  color: #303133;
  padding: 8px 10px;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 5px;
}
.chart-box {
  width: 100%;
  height: 320px;
}
.border {
  border: 1px solid #e8e8e8;
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/FlowTimeoutChar.vue